// src/features/myshrine/useMyDeities.js
import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../api/firebase';
import { useAuth } from '../../context/auth';

/**
 * ログインユーザーの参拝済み御祭神リストを取得する。
 * users/{uid}/visitLog/deities の .deities マップを配列に変換して返す。
 */
export function useMyDeities() {
  const { user } = useAuth();
  const [deities, setDeities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setDeities([]);
      setLoading(false);
      return;
    }
    getDoc(doc(db, 'users', user.uid, 'visitLog', 'deities'))
      .then(snap => {
        if (snap.exists()) {
          const raw = snap.data()?.deities ?? {};
          const list = Object.entries(raw).map(([name, info]) => ({
            name,
            visitCount: info.visitCount ?? 0,
            shrines: Object.keys(info.shrines ?? {}),
          }));
          // 参拝回数の多い順に並べる
          list.sort((a, b) => b.visitCount - a.visitCount);
          setDeities(list);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [user]);

  return { deities, loading };
}
